/**
 * Safe currency and number formatting helpers that never throw
 * runtime exceptions even with null, undefined, NaN, or string values.
 */

export function formatKsh(value?: number | string | null): string {
  if (value === null || value === undefined || value === '') {
    return '0';
  }
  const num = typeof value === 'number' ? value : Number(value);
  if (isNaN(num)) {
    return '0';
  }
  return num.toLocaleString();
}

export function formatNumber(value?: number | string | null): string {
  return formatKsh(value);
}
